export const SPORT_COLOURS = {
    racing: '#136A4D',
    football: '#017BC4',
    default: '#136A4D'
};

export const getSportColour = sport =>
    SPORT_COLOURS[sport] || SPORT_COLOURS.default;
